import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'largeNumberFormat'
})
export class LargeNumberFormatPipe implements PipeTransform {

    transform(value: number, args?: string): string {
        switch (args) {
            case 'k':
                return this.k_format(value);
            case 'comma':
                return this.commas_format(value);
            default:
                return value.toString();
        }
    }

    commas_format(value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    k_format(value) {

        if (value >= 1000 && value < 10000) {
            return `${this.decimalPlaces(value / 1000)}k`;
        }
        if (value >= 10000 && value < 100000) {
            return `${this.decimalPlaces(value / 1000)}k`;
        }
        if (value >= 100000 && value < 1000000) {
            return `${this.decimalPlaces(value / 1000)}k`;
        }
        if (value >= 1000000) {
            return `${this.decimalPlaces(value / 1000000)}m`;
        }
        return `${value}`;
    }

    decimalPlaces(value) {
        let decimal: number = (value - Math.floor(value)) * 10;
        decimal = Number(decimal.toFixed(1));
        if (decimal === 0) {
            return value;
        }
        if (decimal % 1 !== 0) {
            return value.toFixed(2);
        }
        return value.toFixed(1);
    }


}
